export enum ImageFormat {
  webp = 'webp',
  avif = 'avif',
  jpg = 'jpg',
}

export enum ImageFit {
  cover = 'cover',
  contain = 'contain',
}

export enum ImageSize {
  headerImage,
  thumbnail,
  slideshow
}
